import { Checkbox } from "@msuite/ui/checkbox";
import { Email, Phone } from "@msuite/ui/link";
import { Tag } from "@msuite/ui/tag";
import { joinJSXElements } from "@msuite/ui/utils";
import type { ContactMember } from "@msuite/utils/types";
import { getFullName } from "@msuite/utils/users";

/** Props Interface */
interface ProjectContactMemberSelectCardProps {
	contactMember: ContactMember;
	onClick: (contactMemberId: string) => void;
	isIncluded: boolean;
}

export function ProjectContactMemberSelectCard({
	contactMember,
	onClick,
	isIncluded,
}: ProjectContactMemberSelectCardProps) {
	const items = joinJSXElements(
		[
			contactMember.email ? <Email key="email">{contactMember.email}</Email> : null,
			contactMember.phone ? <Phone key="phone">{contactMember.phone}</Phone> : null,
		],
		"/",
	);

	/** Render */
	return (
		<div
			className="h-stack w-full gap-2 cursor-pointer items-start"
			key={contactMember.id}
			data-cy="project-contact-member-select-card"
		>
			<div
				className="h-stack gap-4 flex-1 items-baseline"
				onClick={() => {
					onClick(contactMember.id);
				}}
			>
				<div className="pointer-events-none">
					<Checkbox value={isIncluded} />
				</div>
				<div className="card flex-1 v-stack gap-1">
					<div className="h-stack justify-between">
						<p>{getFullName(contactMember)}</p>
						<Tag
							color={contactMember?._type?.color}
							variant="plain"
						>
							{contactMember?._type?.name}
						</Tag>
					</div>
					{items.length ? <div className="h-stack gap-2">{items}</div> : null}
				</div>
			</div>
		</div>
	);
}
